import Vue from 'vue'
import Router from 'vue-router'
import MyServiceTracking from '../components/ServiceTracking/MyServiceTracking'
import MyApprovedServiceTracking from '../components/ServiceTracking/MyApprovedServiceTracking'
import AllServiceTracking from '../components/ServiceTracking/AllServiceTracking'
import SignIn from '../components/Auth/SignIn'
import SignOut from '../components/Auth/SignOut'
import Customers from '../components/Customers/Customers'
import Services from '../components/Services/Services'
import UserManagement from '../components/Users/UserManagement'
import Invoices from '../components/Invoices/Invoices'
import AuthGuard from './auth-guard'

Vue.use(Router)

const routes = [
  {
    path: '/',
    meta: {roles: ['ADMIN', 'USER']},
    beforeEnter: AuthGuard
  },
  {
    path: '/myTracking',
    name: 'myServiceTracking',
    component: MyServiceTracking,
    meta: {roles: ['USER']},
    beforeEnter: AuthGuard
  },
  {
    path: '/myApprovedTracking',
    name: 'MyApprovedServiceTracking',
    component: MyApprovedServiceTracking,
    meta: {roles: ['USER']},
    beforeEnter: AuthGuard
  },
  {
    path: '/allTracking',
    name: 'allServiceTracking',
    component: AllServiceTracking,
    meta: {roles: ['ADMIN']},
    beforeEnter: AuthGuard
  },
  {
    path: '/customers',
    name: 'customers',
    component: Customers,
    meta: {roles: ['ADMIN']},
    beforeEnter: AuthGuard
  },
  {
    path: '/services',
    name: 'services',
    component: Services,
    meta: {roles: ['ADMIN']},
    beforeEnter: AuthGuard
  },
  {
    path: '/usermgmt',
    name: 'usermgmt',
    component: UserManagement,
    meta: {roles: ['ADMIN']},
    beforeEnter: AuthGuard
  },
  {
    path: '/invoices',
    name: 'invoices',
    component: Invoices,
    meta: {roles: ['ADMIN']},
    beforeEnter: AuthGuard
  },
  {
    path: '/signIn',
    name: 'signIn',
    component: SignIn
  },
  {
    path: '/signOut',
    name: 'signOut',
    component: SignOut,
    beforeEnter: AuthGuard
  }
]

const router = new Router({ routes })

export default router



// WEBPACK FOOTER //
// ./src/router/index.js